module.exports = __webpack_public_path__ + "static/media/colorectal-surgery-icon@2x.a39f18af.png";